/**
 * Nivoda Colour → Color Fix
 * Replaces all instances of "colour" with "color" (case-preserving)
 * on Nivoda-related pages (ring-builder, nv-made-to-order).
 */
(function () {
  function replaceColourInTextNode(node) {
    var val = node.nodeValue;
    if (!val) return;
    if (!/colour/i.test(val)) return;

    node.nodeValue = val
      .replace(/COLOUR/g, 'COLOR')
      .replace(/Colour/g, 'Color')
      .replace(/colour/g, 'color');
  }

  function walkAndReplace(root) {
    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );
    while (walker.nextNode()) {
      replaceColourInTextNode(walker.currentNode);
    }
  }

  function run() {
    if (document.body) {
      walkAndReplace(document.body);
    }
  }

  // Initial runs
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Catch dynamically loaded Nivoda content
  setTimeout(run, 1000);
  setTimeout(run, 3000);
  setTimeout(run, 5000);

  // MutationObserver for ongoing dynamic content
  var debounceTimer;
  var observer = new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(run, 150);
  });

  function startObserver() {
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
